import React from 'react';
import { AlertTriangleIcon, CheckIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { MAIN_MOCKUP, offerItems, pricing } from '../data/unstuckContent';
export function OfferSection() {
  return <section id="offer" className="w-full border-y border-champagne/25 bg-black py-12 sm:py-16" aria-labelledby="offer-title" data-id="element-145" data-mp="df6tw7y1h3je">
      <div className="mx-auto max-w-4xl px-5" data-id="element-146" data-mp="ifkqmtu6wr24">
        <div className="border border-champagne/30 bg-charcoal-950 px-5 py-6 text-center sm:px-8" data-id="element-147" data-mp="mds9pvc4m4gh">
          <CountdownTimer label="Launch pricing — closes in" size="lg" data-id="element-148" data-mp="rey2tu9p7tqj" />
          <p className="mt-4 flex items-center justify-center gap-2 text-[11px] font-medium uppercase tracking-[0.14em] text-rose" data-id="element-149" data-mp="wcr7givcsfop">
            <AlertTriangleIcon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-150" data-mp="2t6kxq6wpo8sa" />
            After that it increases to {pricing.afterLaunch}. It doesn’t come back.
          </p>

          <div className="mx-auto mt-6 max-w-sm" data-id="element-151" data-mp="12ojz6ku2iipz">
            <div className="flex items-baseline justify-between text-[9px] font-medium uppercase tracking-[0.16em] text-muted" data-id="element-152" data-mp="12pczp42fobzo">
              <span data-id="element-153" data-mp="sx799yrty2ml">Limited spots at launch price</span>
              <span className="text-champagne" data-id="element-154" data-mp="svmce2i1m7lk">{pricing.spotsTaken}% taken</span>
            </div>
            <div className="mt-2 h-1 w-full overflow-hidden bg-charcoal-700" role="img" aria-label={`${pricing.spotsTaken} percent of launch-price spots already taken`} data-id="element-155" data-mp="ou0s3w36ir1c">
              <div className="h-full bg-champagne" style={{
              width: `${pricing.spotsTaken}%`
            }} data-id="element-156" data-mp="1clob7ru78xt2" />
            </div>
          </div>
        </div>

        <h2 id="offer-title" className="mt-12 text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-157" data-mp="17oxur3ehg074">
          Choose your UNSTUCK
        </h2>

        <div className="mt-8 grid items-center gap-8 sm:grid-cols-2 sm:gap-10" data-id="element-158" data-mp="3tthk6f20oc0g">
          <img src={MAIN_MOCKUP} alt="The complete UNSTUCK system — six volumes and five strategic bonuses" className="mx-auto w-full max-w-[18rem]" width={1080} height={1080} data-id="element-159" data-mp="2ng7y36bfcd8" />

          <div data-id="element-160" data-mp="3otbqyug3mhg9">
            <p className="font-display text-xl font-semibold uppercase leading-tight text-ivory-50" data-id="element-161" data-mp="3ot3gf97g7o88">
              UNSTUCK — 6 Volumes + 5 Bonuses
            </p>
            <p className="mt-1.5 text-[10px] font-medium uppercase tracking-[0.16em] text-muted" data-id="element-162" data-mp="3fv9ums7b8czb">
              Ideal for: {pricing.idealFor}
            </p>

            <ul className="mt-5 space-y-2 border-t border-charcoal-600 pt-5" data-id="element-163" data-mp="364ewoqkpboy1">
              {offerItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-164" data-mp="2s4467onb0cde">
                  <CheckIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-165" data-mp="2s7045cz5j11u" />
                  <span className="text-[14px] leading-snug text-ivory-100" data-id="element-166" data-mp="2djrwun8yrfv5">{item}</span>
                </li>)}
            </ul>

            <p className="mt-6 text-[12px] uppercase tracking-[0.12em] text-muted line-through" data-id="element-167" data-mp="2mivernwe9p82">
              {pricing.regularPrice}
            </p>
            <p className="mt-1 font-display text-6xl font-semibold leading-none text-ivory-50 sm:text-7xl" data-id="element-168" data-mp="2ij4gz08ga8u1">
              {pricing.today}
              <span className="ml-2 align-middle font-sans text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-169" data-mp="2ri80u6ffys9l">
                USD
              </span>
            </p>

            <div className="mt-6" data-id="element-170" data-mp="317jd21xmkd1p">
              <CtaButton target="checkout" size="md" label="I want my UNSTUCK now →" data-id="element-171" data-mp="318km60v2ypgs" />
            </div>
            <TrustStrip className="mt-3 sm:justify-start" data-id="element-172" data-mp="3f82fmtjbmqwh" />
          </div>
        </div>
      </div>
    </section>;
}